import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  InputNumber,
  Divider,
  DatePicker,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  manageTaxComponentsAPI,
  manageTaxComponentsLabel,
  manageTaxComponentsStatic,
} from "./taxComponents.config";
import styles from "../../../../assets/styles/styles";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Text, Title } = Typography;

const NewPRD0602 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [glAccountOptions, setGlAccountOptions] = useState([]);
  const [glAccountTypeOptions, setGlAccountTypeOptions] = useState([]);
  const [glAccounts, setGlAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getTemplate();
  }, []);

  function getTemplate() {
    setIsLoading(true);

    let body = {
      session,
    };

    BOM.FetchReqAction(body, manageTaxComponentsAPI.getTaxComponentTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempGlAccountTypeOptions = [];

        objList?.glAccountTypeOptions?.forEach((element) => {
          tempGlAccountTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        setGlAccountTypeOptions(tempGlAccountTypeOptions);
        setGlAccountOptions(objList?.glAccountOptions);
        setIsLoading(false);
      }
    });
  }

  function handleOnGLATypeChange(idParam) {
    let tempGlAccounts = [];

    if (idParam === 1) {
      glAccountOptions?.assetAccountOptions?.forEach((element) => {
        tempGlAccounts.push({
          value: element.id,
          label: element.name,
        });
      });
    } else if (idParam === 2) {
      glAccountOptions?.liabilityAccountOptions?.forEach((element) => {
        tempGlAccounts.push({
          value: element.id,
          label: element.name,
        });
      });
    } else if (idParam === 3) {
      glAccountOptions?.equityAccountOptions?.forEach((element) => {
        tempGlAccounts.push({
          value: element.id,
          label: element.name,
        });
      });
    } else if (idParam === 4) {
      glAccountOptions?.incomeAccountOptions?.forEach((element) => {
        tempGlAccounts.push({
          value: element.id,
          label: element.name,
        });
      });
    } else if (idParam === 5) {
      glAccountOptions?.expenseAccountOptions?.forEach((element) => {
        tempGlAccounts.push({
          value: element.id,
          label: element.name,
        });
      });
    }

    setGlAccounts(tempGlAccounts);
  }

  function onCancel() {
    navigate("/prd1300", { replace: false });
  }

  const onSubmit = (formValues) => {
    formValues.startDate = BOM.DateTime(formValues.startDate, "only-date");
    if (formValues.startDate) {
      formValues.dateFormat = "dd MMMM yyyy";
    }

    if (formValues.startDate.includes("undefined")) {
      delete formValues.dateFormat;
      delete formValues.startDate;
    }

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      manageTaxComponentsAPI.createTaxComponent,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, manageTaxComponentsLabel.newTaxComponentMsg);
          navigate("/prd1300");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/prd1300");
          setIsLoading(false);
        },
      }
    );
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={manageTaxComponentsLabel.newTaxComponent}
        pageItems={manageTaxComponentsStatic.newTaxComponentItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              active: true,
              isPenalty: false,
              // chargeAppliesTo: 2,
            }}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {manageTaxComponentsLabel.fxRateSetUp}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={manageTaxComponentsLabel.name}
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(manageTaxComponentsLabel.name),
                    },
                  ]}
                >
                  <Input placeholder={BOM.handlePlaceholderMsg(manageTaxComponentsLabel.name)} />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={manageTaxComponentsLabel.percentage}
                  name="percentage"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(manageTaxComponentsLabel.percentage),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(manageTaxComponentsLabel.percentage)}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={manageTaxComponentsLabel.creditAccountType}
                  name="creditAccountType"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${manageTaxComponentsLabel.creditAccountType} *`,
                      "select"
                    )}
                    options={glAccountTypeOptions}
                    onChange={handleOnGLATypeChange}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={manageTaxComponentsLabel.creditAccount} name="creditAcountId">
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(manageTaxComponentsLabel.creditAccount)}
                    options={glAccounts}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={manageTaxComponentsLabel.startDate} name="startDate">
                  <DatePicker
                    placeholder={BOM.handlePlaceholderMsg(
                      `${manageTaxComponentsLabel.startDate} *`,
                      "select"
                    )}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              {BOM.HasPermission("CREATE_TAXCOMPONENT") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(NewPRD0602);
